/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OasXML } from '../../models/OasXML';

/**
 * Models an OpenAPI 2.0 XML.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasXML
 */
export class Oas20XML extends OasXML {
    constructor() {
        super();
    }
}
Oas20XML["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20XML";
Oas20XML["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




